import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack
} from '@mui/material';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StyledTextField } from '../../common/FormStyles';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

const FollowUpModal = ({ show, handleClose, onSave }) => {
  const [comments, setComments] = useState('');
  const [followUpDateTime, setFollowUpDateTime] = useState(null);
 
  const [state, setState] = useState({followUpDate : ""});
const handleChange = (field, value) =>{
        setState({followUpDate:value})
    }
  const handleSubmit = () => {
    let response = onSave({ comments, followUpDate :state.followUpDate });
    if(response){
        handleClose();
    }
  };

  return (
    // <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Dialog open={show} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Follow-up Details</DialogTitle>
        <DialogContent>
          <Stack spacing={3} mt={1}>
            {/* Comments Text Field */}
               <StyledTextField
                                    fullWidth
                                    label="Date"
                                    type="date"
                                    value={state.followUpDate ? new Date(state.followUpDate).toISOString().slice(0, 10) : ""}
                                    onChange={(e) => handleChange("followUpDate", e.target.value)}
                                    size="small"
                                   
                                />
            <TextField
              label="Comments"
              multiline
              rows={3}
              fullWidth
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              placeholder="Enter comments"
            />
                     
            {/* DateTime Picker */}
            {/* <DateTimePicker
              label="Next Follow-up Date & Time"
              value={followUpDateTime}
              onChange={setFollowUpDateTime}
              renderInput={(params) => <TextField {...params} fullWidth />}
            /> */}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    // </LocalizationProvider>
  );
};

export default FollowUpModal;
